import ContributorRequestResource from "common/resources/Project/Config/Contributor/ContributorRequestResource";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import BaseProjectTeamIdApi from "./BaseProjectTeamIdApi";
import { createFormData } from "utils/FormData";

export default class ProjectLeaderApi extends BaseProjectTeamIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/project-leader`;
	}

	/**
	 * @description Create project leader
	 */
	public async create(projectId: string, projectTeamId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		const formData = createFormData(request);

		if (avatar) formData.append("file", avatar);

		return this.postRequestFormdata<ContributorResponseResource>(this.getBaseUrl({ projectId, projectTeamId }), formData).then((response) =>
			ContributorResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update project leader
	 */
	public async update(projectId: string, projectTeamId: string, contributorId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		const formData = createFormData(request);

		if (avatar) formData.append("file", avatar);

		return this.putRequestFormdata<ContributorResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${contributorId}`, formData).then((response) =>
			ContributorResponseResource.hydrate(response),
		);
	}
}
